import * as React from "react";

const EmailIcon = () => {
  return (
 
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<path d="M0 5C0 3.61929 1.11929 2.5 2.5 2.5H17.5C18.8807 2.5 20 3.61929 20 5V15C20 16.3807 18.8807 17.5 17.5 17.5H2.5C1.11929 17.5 0 16.3807 0 15V5ZM2.5 3.75C1.80964 3.75 1.25 4.30964 1.25 5V5.27113L10 10.5211L18.75 5.27113V5C18.75 4.30964 18.1904 3.75 17.5 3.75H2.5ZM18.75 6.72887L12.8649 10.2599L18.75 13.8815V6.72887ZM18.7078 15.3233L11.6573 10.9845L10 11.9789L8.34272 10.9845L1.29221 15.3233C1.43468 15.8569 1.92144 16.25 2.5 16.25H17.5C18.0786 16.25 18.5653 15.8569 18.7078 15.3233ZM1.25 13.8815L7.1351 10.2599L1.25 6.72887V13.8815Z" fill="#98A2B3"/>
</svg>
  )
}

export default EmailIcon